<template>
  <v-card class="mx-auto" outlined elevation="4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-stepper flat :value="currentStatusStep" alt-labels>
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step class="task-step"
                :key="`${n.step}-step`"
                :complete="getCompletedState(n)"
                :step="n.step"
                :color="getStatusUpdateColor(n)"
              >
                <div class="current-step d-flex align-center justify-center" v-if="currentStatusStep === n.step && n.status !== 'completed'">
                  <div class="current-step-slider"></div>
                </div>
                <strong>
                  <!-- <v-icon size="18" class="mb-1">mdi-road-variant</v-icon> -->
                  {{ getStatusLabel(n.status) }}
                </strong>
                <v-list-item
                  v-for="(history, index) in getStatusHistory(n.status)"
                  :key="`${history.email}-${index}`"
                  style="width: max-content; align-items: center"
                >
                  <v-list-item-content style="align-items: center !important">
                    <span style="align-items: center !important">
                      <v-icon size="18" class="mb-1">mdi-account</v-icon>
                      {{ history.name }}
                    </span>
                    <span style="align-items: center !important">
                      <v-icon size="18" class="mb-1">mdi-calendar</v-icon>
                      {{ getTimeDetails(history.updatedDate) }}
                    </span>
                  </v-list-item-content>
                </v-list-item>
              </v-stepper-step>
              <v-divider
                v-if="n.step !== steps.length"
                :key="n.step"
              ></v-divider>
            </template>
          </v-stepper-header>
        </v-stepper>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" class="text-right">
        <v-tooltip
          v-if="
            isMainView &&
            ($security.checkUserAccess('UpdateTask') || isAssigneeChangeStatus)
          "
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :disabled="
                currentStatusStep > steps.length || currentStatusStep == 1
              "
              icon
              small
              @click="$emit('back', getBackNextStatus(true))"
            >
              <v-icon color="primary" small>mdi-step-backward</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("task.tipBackStatus") }}</span>
        </v-tooltip>
        <span
          v-if="
            isMainView &&
            ($security.checkUserAccess('UpdateTask') || isAssigneeChangeStatus)
          "
          class="text-uppercase change-status primary--text ml-2 mr-2"
          >{{ $t("task.lblChangeStatus") }}</span
        >
        <v-tooltip
          v-if="
            isMainView &&
            ($security.checkUserAccess('UpdateTask') || isAssigneeChangeStatus)
          "
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :disabled="currentStatusStep >= steps.length"
              icon
              small
              @click="$emit('next', getBackNextStatus(false))"
            >
              <v-icon small color="primary">mdi-step-forward</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("task.tipForwardStatus") }}</span>
        </v-tooltip>
        <change-log-history :statusHistory="statusHistory"></change-log-history>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ChangeLogHistory from "./ChangeLogHistory.vue";
import { getTimeDetails } from "@/utils/util";
import { mapGetters } from "vuex";

export default {
  components: { ChangeLogHistory },
  name: "WorkFlowStatus",
  props: {
    taskDetails: {
      type: Object,
      default: () => {},
    },
    isMainView: Boolean,
  },
  data() {
    return {
      steps: [
        {
          step: 1,
          status: "todo",
        },
        {
          step: 2,
          status: "inProgress",
        },
        {
          step: 3,
          status: "completed",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getStatusLabel: "task/getStatusLabel",
    }),
    statusHistory() {
      return this.taskDetails.statusHistory || [];
    },
    currentStatusStep() {
      const result = this.steps.find(
        (item) => item.status === this.taskDetails.status
      );
      return result?.step || 1;
    },
    isAssigneeChangeStatus() {
      return this.taskDetails.assignees.some(
        (item) => item.id === this.$auth.user.user_id
      );
    },
  },
  methods: {
    getTimeDetails,
    getStatusHistory,
    getBackNextStatus,
    getStatusUpdateColor,
    getCompletedState,
  },
};

function getCompletedState(n) {
  return (
    (this.currentStatusStep === n.step && n.status === "completed") ||
    this.currentStatusStep > n.step
  );
}

function getStatusUpdateColor(n) {
  return this.currentStatusStep === n.step && n.status !== "completed"
    ? "primary lighten-2"
    : "success lighten-2";
}

function getBackNextStatus(isBack) {
  let nextBackIndex;
  if (isBack) {
    nextBackIndex = this.currentStatusStep - 1;
  } else {
    nextBackIndex = this.currentStatusStep + 1;
  }
  return this.steps[nextBackIndex - 1].status;
}

function getStatusHistory(status) {
  const history = this.statusHistory
    .filter((item) => item.status === status)
    .sort((a, b) => new Date(b.updatedDate) - new Date(a.updatedDate));

  return history.length ? [history[0]] : [];
}
</script>

<style scoped>
::v-deep .v-stepper .v-stepper__step--complete .v-stepper__label {
  align-items: center !important;
}

.change-status {
  font-size: 12px !important;
}
.current-step {
  width: 100%; 
}
.current-step-slider {
  width: 60px;
  border-top: 5px solid #5a9fe5 !important;
}
.task-step /deep/ .v-stepper__step__step {
  margin-bottom: 6px !important;
}
</style>